<template>
  <i
    v-if="visible"
    class="fas fa-exclamation-triangle text-warning missing-prepayment-warning"
    :title="resolvedTooltip"
    :aria-label="resolvedTooltip"
    role="img"
  />
</template>

<script>
import {
  buildMissingPrepaymentTooltip,
  hasMissingAssociatedPrepayment,
} from "@/utils/missingPrepaymentWarning";

/**
 * Ticket #328 — interruptor del triángulo en front.
 * En `false` la lógica de util/hooks/list fields se mantiene, pero el icono no se muestra.
 */
const SHOW_MISSING_PREPAYMENT_WARNING_ICON = true;

export default {
  name: "MissingPrepaymentWarningIcon",
  props: {
    /** Si se pasa, se calcula con hasMissingAssociatedPrepayment(record). */
    record: {
      type: Object,
      default: null,
    },
    /**
     * Si true, muestra sin mirar record.
     * Si false, oculta.
     * Si se omite, usa record.
     */
    show: {
      type: Boolean,
      default: undefined,
    },
    /** Tooltip fijo (opcional). Si no, se arma desde shippings pendientes o leyenda base. */
    tooltip: {
      type: String,
      default: "",
    },
  },
  computed: {
    visible() {
      if (!SHOW_MISSING_PREPAYMENT_WARNING_ICON) return false;
      if (this.show === true) return true;
      if (this.show === false) return false;
      return hasMissingAssociatedPrepayment(this.record);
    },
    baseLabel() {
      return this.$t("Sin prepayment asociado");
    },
    resolvedTooltip() {
      if (this.tooltip) return this.tooltip;
      return buildMissingPrepaymentTooltip(this.record, this.baseLabel);
    },
  },
};
</script>

<style scoped>
.missing-prepayment-warning {
  font-size: 0.85em;
  cursor: help;
  flex-shrink: 0;
  white-space: pre-line;
}
</style>
